import { Button, Col, Form, FormInstance, Input, Modal, Row, Space } from "antd";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteChildrenProps } from "react-router";
import ControlFailureEventTypeImage from "../../../assets/images/test-data/control_failure_event_type.svg";
import controlFailureFunctionalImage from "../../../assets/images/test-data/control_failure_functional.svg";
import ecapAndScenarioImage from "../../../assets/images/test-data/ecap_scenario.svg";
import rapmImage from "../../../assets/images/test-data/rapm.svg";
import { DateFormat, VALIDATION_MESSAGE_CONFIG } from "../../../constants/constants";
import { DashboardEcapModuleModel, DashboardERMModel, DashboardRAPMModel, DashboardScenarioModel } from "../../../models/dashboad/dashboard.model";
import { DashboardService } from "../../../services/dashboard.service";
import UTIL from "../../../utils/utils";
import AmountInput from "../../atoms/amount-input";
import { RefreshIcon, SettingIcon } from "../../atoms/icon";
import DashboardControlFailure from "./control-failure";
import "./ecap-dashboard.scss";
import DashboardEcapModule from "./ecap-module";
import DashboardRapmComponent from "./rapm";
import DashboardScenario from "./scenario";


export const ChartFont = {
    size: 10,
    family: "'Roboto', sans-serif"
}

interface Props extends RouteChildrenProps { }
const EcapDashboardComponent = (props: Props) => {

    const { t } = useTranslation();
    const [rapmData, setRapmData] = useState<DashboardRAPMModel[]>([]);
    const [ermFunctionalData, setErmFunctionalData] = useState<DashboardERMModel[]>([]);
    const [ermEventTypeData, setErmEventTypeData] = useState<DashboardERMModel[]>([]);
    const [scenarioData, setScenarioData] = useState<DashboardScenarioModel[]>([]);
    const [ecapModuleData, setEcapModuleData] = useState<DashboardEcapModuleModel[]>([]);
    const [isShowModal, setShowModal] = useState<boolean>(false);
    const formRef = useRef<FormInstance<any>>(null);
    const [showTestData, setShowTestData] = useState(false);

    const getControlFailureLossDatabaseFunctional = () => {
        DashboardService.getControlFailureLossDatabaseFunctionalAsync().then(res => {
            const d: DashboardERMModel[] = (res.data as any[]).map(item => {
                item.label = item.business_unit?.name;
                item.chartColor = UTIL.randomColor(item.business_unit?.name);
                item.checkboxId = UTIL.removeSpaces(item.business_unit?.name);
                return item;
            })
            setErmFunctionalData(d);
        });
    }

    const getControlFailureLossDatabaseEventType = () => {
        DashboardService.getControlFailureLossDatabaseEventTypeAsync().then(res => {
            const d: DashboardERMModel[] = (res.data as any[]).map(item => {
                item.label = item.basel_2_level_1_category?.name;
                item.chartColor = UTIL.randomColor(item.basel_2_level_1_category?.name);
                item.checkboxId = UTIL.removeSpaces(item.basel_2_level_1_category?.name);
                return item;
            })
            setErmEventTypeData(d);
        });
    }

    const getRapmData = () => {
        DashboardService.getRapmDataAsync().then(res => {
            if (res.data) {
                (res.data as DashboardRAPMModel[]).forEach(item => {
                    item.markerColor = UTIL.randomColor(item.segment);
                    item.checkboxId = UTIL.removeSpaces(item.segment);
                })
                setRapmData(res.data);
            }
        });
    }

    const getScenarioData = () => {
        DashboardService.getScenariosDataAsync().then(res => {
            setScenarioData(res.data);
        });
    }

    const getEcapData = () => {
        DashboardService.getEcapModuleDataAsync().then(res => {
            setEcapModuleData(res.data);
        });
    }

    const setAvailableCapitalDataForm = () => {

        if (formRef.current) {
            const data = ecapModuleData.map(x => ({
                year: x.year,
                amount: x.available_capital
            }))


            formRef.current.setFieldsValue({ data: data });

        }
    }

    const refreshEcapData = () => {
        DashboardService.refreshtEcapModuleDataAsync().then(res => {
            setEcapModuleData(res.data);
        });
    }


    const submitAvailableCapital = (values: any) => {
        DashboardService.updateAvailableCapitalAsync(values).then(res => {
            setShowModal(false);
            setEcapModuleData(res.data);
        })
    }

    useEffect(() => {
        if (isShowModal) {
            setAvailableCapitalDataForm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isShowModal])

    useEffect(() => {
        getControlFailureLossDatabaseFunctional();
        getControlFailureLossDatabaseEventType();
        getRapmData();
        getScenarioData();
        getEcapData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (

        <div className="ecap-dashboard-wrapper">
            <Row className="header-page">
                <Col sm={24}>
                    <h4>
                        {t("Dashboard.headerTitle")}
                        <b> {moment().format(DateFormat.view)}</b>
                    </h4>
                </Col>
            </Row>

            <Row gutter={[18, 18]} className={!showTestData ? "hidden" : ""}>
                <Col span={24} >
                    <img className="img-test-data" src={rapmImage} alt="" />
                </Col>
                <Col span={12}>
                    <img className="img-test-data" src={ecapAndScenarioImage} alt="" />
                </Col>
                <Col span={12}>
                    <Row gutter={[20, 20]}>
                        <Col span={24}>
                            <img className="img-test-data" src={controlFailureFunctionalImage} alt="" />
                        </Col>
                        <Col span={24}>
                            <img className="img-test-data" src={ControlFailureEventTypeImage} alt="" />
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row className={showTestData ? "hidden" : ""} gutter={[24, 24]}>
                <Col span={24} >
                    <div className="session-wrapper">
                        <DashboardRapmComponent data={rapmData} />
                    </div>
                </Col>


                <Col span={24}>
                    <Row gutter={[24, 24]}>
                        <Col span={12}>
                            <div className="session-wrapper">
                                <Space className="right-menu">
                                    <Button type="text" shape="circle" onClick={() => refreshEcapData()}>
                                        <RefreshIcon />
                                    </Button>
                                    <Button type="text" shape="circle" onClick={() => setShowModal(true)}>
                                        <SettingIcon />
                                    </Button>
                                </Space>

                                <DashboardEcapModule data={ecapModuleData} />
                            </div>
                        </Col>
                        <Col span={12}>
                            <div className="session-wrapper">
                                <DashboardControlFailure
                                    chartId="functionalChart"
                                    title={t("Dashboard.ttControlFailureFunctional")}
                                    data={ermFunctionalData} />
                            </div>
                        </Col>
                    </Row>
                </Col>

                <Col span={24}>
                    <Row gutter={[24, 24]}>
                        <Col span={12}>
                            <div className="session-wrapper">
                                <DashboardScenario data={scenarioData} />
                            </div>
                        </Col>
                        <Col span={12}>
                            <div className="session-wrapper">
                                <DashboardControlFailure
                                    chartId="eventTypeViewChart"
                                    title={t("Dashboard.ttControlFailureEventType")}
                                    data={ermEventTypeData} />
                            </div>
                        </Col>
                    </Row>
                </Col>

            </Row>

            <Button
                onClick={() => setShowTestData(pre => !pre)}
                type="primary" shape="round"
                style={{
                    margin: '0 auto',
                    marginTop: '15px'
                }}>
                {showTestData ? "Hide Test Data" : "Show Test Data"}
            </Button>

            <Modal
                className="availabe-capital-modal"
                title={t("Dashboard.lbConfigure")}
                visible={isShowModal}
                onCancel={() => setShowModal(false)}
                footer={<Button style={{ display: "initial" }} htmlType="submit" type="primary" shape="round" onClick={() => formRef.current?.submit()}>
                    {t("Dashboard.lbSave")}
                </Button>}
            >

                <Form
                    layout="vertical"
                    className="modal-form"
                    onFinish={submitAvailableCapital}
                    ref={formRef}
                    validateMessages={VALIDATION_MESSAGE_CONFIG}>

                    <Form.List
                        name="data"

                    >

                        {(fields) => (
                            <div className="form-list">
                                {fields.map((field, index) => (
                                    <Row gutter={12} key={field.fieldKey}>
                                        <Col span={12}>
                                            <Form.Item name={[field.name, "year"]}
                                                label={index === 0 ? t("Dashboard.lbYears") : null} >
                                                <Input disabled />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item name={[field.name, "amount"]}
                                                label={index === 0 ? " " : null} >
                                                <AmountInput />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                ))}
                            </div>
                        )}

                    </Form.List>

                </Form>

            </Modal>

        </div>)
}

export default React.memo(EcapDashboardComponent)